<template>
    <div class="investment_index">
        <div class="top">
            <p class="p1">{{userInfo.name}}，{{headTime}}</p>
            <p class="p2">{{userInfo.orgName}}</p>
        </div>
        <div class="boody">
            <div class="title_list">
                <div class="box">
                    <div @click="$router.push({path: '/investment/information'})">
                        <div class="point">
                            <img class="small_img" src="../../../assets/investment/Information.png" alt="">
                            <!-- <div class="icon" v-if="information">
                                <span>{{information}}</span>
                            </div> -->
                        </div>
                        <p class="deep">信息发布管理</p>
                    </div>
                    <div @click="$router.push({path: '/investment/pendingReview'})">
                        <div class="point">
                            <img class="small_img" src="../../../assets/investment/project.png" alt="">
                            <!-- <div class="icon" v-if="pendingReview">
                                <span>{{pendingReview}}</span>
                            </div> -->
                        </div>
                        <p class="deep">项目管理</p>
                    </div>
                </div>
                <div class="box">
                    <div @click="$router.push({path: '/investment/message'})">
                        <div class="point">
                            <img class="big_img" src="../../../assets/investment/message.png" alt="">
                            <!-- <div class="icon" v-if="message">
                                <span>{{message}}</span>
                            </div> -->
                        </div>
                        <p class="hide">留言管理</p>
                    </div>
                    <div @click="$router.push({path: '/investment/investor'})">
                        <div class="point">
                            <img class="big_img" src="../../../assets/investment/investment.png" alt="">
                        </div>
                        <p class="hide">投资方管理</p>
                    </div>
                    <div @click="$router.push({path: '/investment/activity'})">
                        <div class="point">
                            <img class="big_img" src="../../../assets/investment/attract.png" alt="">
                        </div>
                        <p class="hide">招商活动管理</p>
                    </div>
                </div>
            </div>
            <div class="content_list">
                <listItem v-for="(item , index) in listItem" :key = index :title="item.title" :list="item.list"></listItem>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions} from 'vuex'
import listItem from '../components/listItem.vue';
import apis from "../../../service/modules/index";

export default {
    name: "InvestmentIndex",
    components: {
        listItem
    },
    data() {
        return {
            listItem:[
                {
                    "title":"留言管理",
                    "list":[
                        {
                            name: '全部留言',
                            amount: 0
                        },
                        {
                            name: '待处理',
                            amount: 0
                        },
                        {
                            name: '已处理',
                            amount: 0
                        }
                    ]
                },
                {
                    "title":"信息发布管理",
                    "list":[
                        {
                            name: '全部信息',
                            amount: 0
                        },
                        {
                            name: '招商项目',
                            amount: 0
                        },
                        {
                            name: '营商环境',
                            amount: 0
                        },
                        {
                            name: '其他',
                            amount: 0
                        }
                    ]
                },
                {
                    "title":"项目管理",
                    "list":[
                        {
                            name: '全部项目',
                            amount: 0
                        },
                        {
                            name: '储备',
                            amount: 0
                        },
                        {
                            name: '意向',
                            amount: 0
                        },
                        {
                            name: '签约',
                            amount: 0
                        },
                        {
                            name: '落地',
                            amount: 0
                        },
                        {
                            name: '完成',
                            amount: 0
                        },
                        {
                            name: '暂缓',
                            amount: 0
                        },
                        {
                            name: '退出',
                            amount: 0
                        }
                    ]
                },
                {
                    "title":"投资方管理",
                    "list":[
                        {
                            name: '全部投资方',
                            amount: 0
                        },
                        {
                            name: '全球500强',
                            amount: 0
                        },
                        {
                            name: '全国500强',
                            amount: 0
                        },
                        {
                            name: '行业龙头',
                            amount: 0
                        },
                        {
                            name: '大型民企',
                            amount: 0
                        },
                        {
                            name: '国际知名品牌',
                            amount: 0
                        },
                        {
                            name: '国内知名品牌',
                            amount: 0
                        },
                        {
                            name: '其他',
                            amount: 0
                        }
                    ]
                },
                {
                    "title":"招商活动管理",
                    "list":[
                        {
                            name: '赴外招商',
                            amount: 0
                        },
                        {
                            name: '客商来滇',
                            amount: 0
                        },
                        {
                            name: '会见客商',
                            amount: 0
                        },
                        {
                            name: '驻外招商',
                            amount: 0
                        },
                        {
                            name: '推介会',
                            amount: 0
                        }
                    ]
                }
            ],
            information: 0,
            pendingReview: 0,
            message: 0,
            userInfo: {
                name:'',
                orgName:'',
            },
            headTime: '早上好'
        };
    },
    computed: {
        
    },
    created() {
        
        if(this.$store.state.guide.userInfo){
            this.userInfo = this.$store.state.guide.userInfo
        }else{
            apis.getIndexUserInfo().then((res) => {
                if(res.ret == 0){
                    this.userInfo = res.data
                }
            })
        }

        let hour = new Date().getHours();
        if (hour < 6) {
            this.headTime = "凌晨好";
        } else if (hour < 9) {
            this.headTime = "早上好";
        } else if (hour < 12) {
            this.headTime = "上午好";
        } else if (hour < 14) {
            this.headTime = "中午好";
        } else if (hour < 17) {
            this.headTime = "下午好";
        } else if (hour < 19) {
            this.headTime = "傍晚好";
        } else if (hour < 22) {
            this.headTime = "晚上好";
        } else {
            this.headTime = "夜里好";
        }
        
        this.setInvestmentTitle('招商引资')
        // this.getTotalUndone().then(res=>{
        //     this.message = res
        // })
        // this.getPublicUnDone().then(res=>{
        //     this.information = res
        // })
        // this.getVerifying().then(res=>{
        //     this.pendingReview = res
        // })
        this.getTotalMessage().then(res=>{
            this.listItem[0].list[0].amount = res.done + res.unDone
            this.listItem[0].list[1].amount = res.unDone
            this.listItem[0].list[2].amount = res.done
        })
        this.getPublicTotal().then(res=>{
            this.listItem[1].list[0].amount = res.investProject + res.other + res.busiEnv
            this.listItem[1].list[1].amount = res.investProject
            this.listItem[1].list[2].amount = res.busiEnv
            this.listItem[1].list[3].amount = res.other
        })
        this.getProgressNum().then(res=>{
            res.forEach(element => {
                this.listItem[2].list[0].amount = this.listItem[2].list[0].amount + element.progressNum
                this.listItem[2].list[element.progress].amount = element.progressNum
            });
            
        })
        this.getInvestorNum().then(res=>{
            res.forEach(element => {
                if(element.code == 'total'){
                    this.listItem[3].list[0].amount = element.value
                }else{
                    element.code++
                    this.listItem[3].list[element.code].amount = element.value
                }
            });
            
        })
        this.getPrInvestmentManage().then(res=>{
            this.listItem[4].list[0].amount = res.investmentOut ? res.investmentOut:0
            this.listItem[4].list[1].amount = res.merchantsToYunnan ? res.merchantsToYunnan:0
            this.listItem[4].list[2].amount = res.meetingMerchants ? res.meetingMerchants:0
            this.listItem[4].list[3].amount = res.residentInvestPers ? res.residentInvestPers:0
            this.listItem[4].list[4].amount = res.specialInvestActi ? res.specialInvestActi:0
        })
    },
    watch: {},
    methods: {
        ...mapActions('investment', [
            'setInvestmentTitle',
            'getTotalUndone',
            'getPublicUnDone',
            'getVerifying',
            'getTotalMessage',
            'getPublicTotal',
            'getProgressNum',
            'getInvestorNum',
            'getPrInvestmentManage'
        ]),
    },
    mounted() {
        const van_dropdown_item_down =  document.getElementsByClassName("van-dropdown-item--down");
        
        for (const key in van_dropdown_item_down) {
            try {
                van_dropdown_item_down[key].style['display'] = "none";
            } catch (error) {
                
            }
            
        }
    },
};
</script>

<style lang="less" scoped>
.investment_index {
    background: #F5F6F9;

    .top{
        background: #36B374;
        padding: 12px 16px 36px;
        color: #FFFFFF;

        .p1{
            font-size: 20px;
            font-weight: bold;
            padding-bottom: 6px;
            line-height: 28px;
        }
        .p2{
            font-size: 14px;
            line-height: 20px;

        }
    }
    .boody{
        padding: 0 12px 42px;
        .title_list{
            background: #FFFFFF;
            padding: 1px 20px;
            border-radius: 3px;
            margin-top: -19px;
            .box{
                display: flex;
                justify-content: space-around;
                font-size: 12px;
                text-align: center;
                padding: 11px 0;
                .small_img{
                    display: inline-block;
                    width: 26px;
                    height: 26px;
                    margin-top: 6px;
                    margin-bottom: 5px;
                }
                .big_img{
                    display: inline-block;
                    width: 36px;
                    height: 36px;
                }
                .deep{
                    color: #333333;
                    line-height: 17px;
                }
                .hide{
                    color: #666666;
                    line-height: 17px;
                }
                .point{
                    position: relative;
                    display: inline-block;
                    .icon{
                        background: #FF4D4D;
                        color: #FFFFFF;
                        line-height: 11px;
                        padding: 1.5px 3.5px 0.5px;
                        border: 1.5px solid #FFFFFF;
                        border-radius: 14px;
                        position: absolute;
                        top: -2px;
                        left: 20px;
                        min-width: 21px;
                    }
                    span{
                            display: block;
                            font-size: 12px;
                            transform: scale(0.666);
                        }
                }
            }
        }
    }
}
</style>